import { ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'
import { useEditSession } from '@/core/store/editSession'
import { MorePanelId } from '@/core/store/uiState'
import { cn } from '@/lib/utils'

export function MoreSection({ id, children, className }: { id: MorePanelId; children: ReactNode; className?: string }) {
  const open = useEditSession((state) => state.moreSectionsOpen.has(id))
  const setOpen = useEditSession((state) => state.setMoreSectionOpen)
  return (
    <div className={cn('border-t pt-2', className)}>
      <button
        type="button"
        className="flex h-9 w-full items-center justify-between rounded-md px-2 text-sm font-medium outline-offset-2 hover:bg-muted"
        aria-expanded={open}
        onClick={() => setOpen(id, !open)}
      >
        More
        <ChevronDown className={cn('size-4 transition-transform', open && 'rotate-180')} aria-hidden="true" />
      </button>
      {open ? <div className="space-y-4 px-2 pb-1 pt-3">{children}</div> : null}
    </div>
  )
}
